import { useState } from 'react';

import './DevBranchHeader.scss';

const DEV_BRANCH_META_NAME = 'willow-dev-branch';

interface DevBranchInfo {
  branch: string;
  prUrl?: string;
}

const readDevBranchInfo = (): DevBranchInfo | undefined => {
  const meta = document.querySelector<HTMLMetaElement>(`meta[name="${DEV_BRANCH_META_NAME}"]`);
  if (!meta?.content) {
    return undefined;
  }
  return { branch: meta.content, prUrl: meta.dataset.prUrl };
};

export const DevBranchHeader = () => {
  const [info] = useState(readDevBranchInfo);

  if (!info) {
    return null;
  }

  const prNumber = info.prUrl?.split('/').pop();

  return (
    <div className="dev-branch-header">
      <span className="dev-branch-header__branch">{info.branch}</span>
      {info.prUrl && prNumber && (
        <a className="dev-branch-header__pr" href={info.prUrl} target="_blank" rel="noreferrer">
          PR #{prNumber}
        </a>
      )}
    </div>
  );
};
